<app-shared-engagement-table
  [loading]="loading"
  [prevDocumentType]="prevDocumentType"
  [engagementList]="engagementList"
  (refreshList)="
    initializeCustomerAckReviewList()
  "></app-shared-engagement-table>
